module.exports = __webpack_public_path__ + "img/jordflomskredaktsomhet.2491a693.jpg";